<template>
  <div>
    <v-list-tile ripple @click="markAsReadAndRedirect">
      <v-list-tile-content>
        <v-tooltip bottom>
          <template slot="activator">
            <v-list-tile-title>
              <v-icon color="red" small class="alert-icon" v-if="isCritical">error</v-icon>
              <span> {{ getTitle() }}</span>
            </v-list-tile-title>
            <v-list-tile-sub-title style="max-width: 400px" class="text--primary">{{ item.notification.message }}</v-list-tile-sub-title>
            <v-list-tile-action-text>{{ item.notification.createdAt }}</v-list-tile-action-text>
          </template>
          <span>Visualizar</span>
        </v-tooltip>
      </v-list-tile-content>

      <v-list-tile-action>
        <v-tooltip bottom v-if="!item.read">
          <v-btn slot="activator" icon flat @click.stop="markAsRead(false)">
            <v-icon>visibility</v-icon>
          </v-btn>
          <span>Marcar como leído</span>
        </v-tooltip>
      </v-list-tile-action>
    </v-list-tile>
    <v-divider></v-divider>
    </div>
</template>

<script>
import constants from '../constants'
export default {
  props: {
    item: Object,
    isCritical: Boolean
  },

  methods: {
    goRoute () {
      let contentType = this.item.notification.contentType
      if (contentType === 'Liquidaciones') {
        contentType = this.item.notification.contentTypeClass
      }
      if (contentType === 'Expedientes') {
        return this.$router.push({ name: 'notificaciones' })
      }
      let route = contentType
        ? { name: constants.NOTIFICATION_ROUTES[contentType], params: { id: this.item.notification.objectId } }
        : { name: 'notificaciones' }
      let isSameRoute = this.$router.currentRoute.name === constants.NOTIFICATION_ROUTES[contentType]
      this.$router.push(route)
      if (isSameRoute) {
        this.$router.go()
      }
    },
    markAsRead (redirect) {
      if (!this.item.read) {
        this.item.read = true
        this.$emit('decrease')
        this.axios
          .put(`notification/read/${this.item.id}`)
          .then(() => {
            if (redirect) {
              this.goRoute()
            }
          })
          .catch(error => { this.$store.commit('setErrorMsg', error) })
      } else {
        this.goRoute()
      }
    },
    markAsReadAndRedirect () {
      this.markAsRead(true)
    },
    getTitle () {
      let contentType = this.item.notification.contentType
      if (contentType === 'Informe_pagos') {
        contentType = this.item.notification.contentTypeClass
      } else if (contentType === 'Deudas_entre_clubes') {
        contentType = 'Deudas entre clubes'
      }
      return (contentType ? `${contentType} - ` : '') + this.item.notification.title
    }
  }
}
</script>

<style scoped>
.alert-icon {
  padding-bottom: 0.1em
}
</style>
